export default {
  widgets: {
    shippedItems: {
      filters: {
        search: {
          placeholder: 'Поиск...',
        },
        statuses: {
          placeholder: 'Статус',
          options: ['Новый', 'В процессе', 'Пропущено', 'Завершено', 'Отменено', 'Все'],
          new: 'Новый',
          processing: 'В процессе',
          missed: 'Пропущено',
          completed: 'Завершено',
          canceled: 'Отменено',
        },

        reset: 'Сбросить',
      },
      showBy: 'Показывать по',
      headers: {
        invoiceId: 'ID-Накладной',
        name: 'Название',
        items: 'Товары',
        itemsQuantity: 'Количество товаров',
        dateAndTime: 'Дата и время',
        status: 'Статус',
        sku: 'SKU',
        ikpu: 'ИКПУ',
        price: 'Цена (сум)',
        price_brutto: 'Цена с НДС',
        quantity: 'На складе',
        inAlifshop: 'В Алифшопе',
      },
      noOffer: 'Товар не привязан',
    },
  },
};
